module.exports = __webpack_public_path__ + "media/images/icon_arrow_white-734023869604f9bf181501fe61c839ed.png";